import React, { useState } from "react";
import BorrowerFrequentlyAskedQuestions from "../Help/BorrowerFrequentlyAskedQuestions";
import ContactUs from "../Help/ContactUs";
import TermsOfService from "../Help/TermsOfService";
import Dropdown from "../../components/Tools/Helper-Components/Dropdown";
import classes from "../../components/Tools/Tools-CSS/CSPQuickAccountLookup.module.css";

function Help() {
  const [selected, setSelected] = useState("Contact Us");
  const options = [
    "Contact Us",
    "Borrower Frequently Asked Questions",
    // "Training or How-to Videos",
    "Terms of Service",
  ];

  return (
    <div
      
      //   style={{ overflowY: "scroll" }}
    >
      <section
        className="rounded container-fluid"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <div className="p-3 pb-0  mt-1">
          <h4 className="mt-4 mb-3">Help</h4>

          <div className="d-flex justify-content-between align-items-center">
            <ul className={classes.unorderedList}>
              <li>Help</li>
              <li>
                <span className={classes.spanMargin}>\</span>
              </li>
              <li className={classes.breadcrumbColor}>{selected}</li>
            </ul>
            <Dropdown
              options={options}
              selected={selected}
              setSelected={setSelected}
              classname={classes.zIndex}
            />
          </div>
          {selected === "Contact Us" && <ContactUs />}
          {selected === "Borrower Frequently Asked Questions" && (
            <BorrowerFrequentlyAskedQuestions />
          )}
          {selected === "Terms of Service" && <TermsOfService />}
        </div>
      </section>
    </div>
  );
}

export default Help;
